import React, { memo, SVGProps } from 'react'

export const ArrowsUpDown = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12.5089 13.0916C12.2276 12.8104 11.7716 12.8104 11.4903 13.0916C11.3502 13.2318 11.2791 13.4161 11.2791 13.6004C11.2791 13.7848 11.3492 13.9691 11.4903 14.1092L14.9454 17.5643C15.0116 17.6305 15.0913 17.6833 15.1796 17.7198C15.3553 17.7928 15.554 17.7928 15.7297 17.7198C15.818 17.6833 15.8977 17.6305 15.9639 17.5643L19.419 14.1092C19.7003 13.828 19.7003 13.372 19.419 13.0907C19.1377 12.8094 18.6817 12.8094 18.4004 13.0907L16.1751 15.316L16.1751 2.88972C16.1751 2.49228 15.8526 2.16972 15.4551 2.16972C15.0577 2.16972 14.7351 2.49228 14.7351 2.88972L14.7351 15.3169L12.5089 13.0916Z"
      fill="currentColor"
    />
    <path
      d="M9.26506 21.1124L9.26506 8.68524L11.4903 10.9105C11.7716 11.1918 12.2276 11.1918 12.5089 10.9105C12.7902 10.6292 12.7902 10.1732 12.5089 9.89196L9.05386 6.43692C8.98762 6.37068 8.90794 6.31788 8.81962 6.2814C8.64394 6.20844 8.44522 6.20844 8.26954 6.2814C8.18122 6.31788 8.10155 6.37068 8.0353 6.43692L4.58026 9.89196C4.4401 10.0321 4.36906 10.2164 4.36906 10.4008C4.36906 10.5851 4.43914 10.7694 4.58026 10.9096C4.86154 11.1908 5.31755 11.1908 5.59883 10.9096L7.8241 8.68428L7.8241 21.1115C7.8241 21.5089 8.14666 21.8315 8.5441 21.8315C8.94154 21.8315 9.2641 21.5089 9.2641 21.1115L9.26506 21.1124Z"
      fill="currentColor"
    />
  </svg>
))
